import { FC } from 'react'

import { CatchNotFound } from '@tanstack/react-router'
import { NotFound } from 'bank-portal/src/modules/404'
import { CircularProgress } from 'ui/components'

import { BPLayoutProps } from './BPLayoutProps'
import { AccountMenu } from './components/AccountMenu'
import { GlobalSearch } from './components/GlobalSearch'
import { Page } from './components/Page'
import { useBPLayout } from './hooks'

export const BPLayout: FC<BPLayoutProps> = ({ children, sidebar }) => {
  const { layout, barMinimized, changeBarMinimized, menuItems, connectionsItems, sideBar } = useBPLayout(sidebar)

  if (!layout) {
    return <CircularProgress centered />
  }

  const {
    header: { name, accountMenuItems }
  } = layout

  return (
    <Page
      headerChildren={
        <>
          <GlobalSearch />
          <AccountMenu userName={name} canAccessAccountSettings={accountMenuItems.indexOf('settings') != -1} />
        </>
      }
      barMinimized={barMinimized}
      onToggleBar={changeBarMinimized}
      menuItems={menuItems}
      connectionsItems={connectionsItems}
      menuSecondaryMenuPane={sideBar}
    >
      <CatchNotFound fallback={() => <NotFound />}>{children}</CatchNotFound>
    </Page>
  )
}
